import React, { useEffect, useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { googleLogin } from "../api/auth";
import { AuthContext } from "../context/AuthContext";
import LoadingLines from "../components/LoadingLines";

const GoogleCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMsg, setErrorMsg] = useState("");
  const { login } = useContext(AuthContext);

  const handleGoogleAuth = async (idToken) => {
    try {
      const res = await googleLogin(idToken);

      login(res.data.user, {
        access: res.data.tokens.access,
        refresh: res.data.tokens.refresh,
      });

      // First-time Google users pick a plan; returning users go straight in.
      navigate(res.data.is_new_user ? "/choose-plan" : "/portfolio", {
        replace: true,
      });
    } catch (error) {
      console.error("Google auth error:", error);
      setErrorMsg(error.response?.data?.detail || "Backend failed to verify Google token.");
      setTimeout(() => navigate("/login?error=google_auth_failed"), 5000);
    }
  };

  useEffect(() => {
    const parseToken = async () => {
      // Sometimes it's in location.hash, sometimes in query params if response_mode varies
      const hashParams = new URLSearchParams(location.hash.substring(1));
      const queryParams = new URLSearchParams(location.search);
      
      const idToken = hashParams.get("id_token") || queryParams.get("id_token");

      if (idToken) {
        await handleGoogleAuth(idToken);
      } else {
        setErrorMsg("No ID token found in the URL. Hash was: " + location.hash + " Search was: " + location.search);
        setTimeout(() => navigate("/login?error=google_auth_failed"), 5000);
      }
    };
    parseToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  if (errorMsg) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#060B12] px-4">
        <div className="bg-red-500/10 border border-red-500/40 p-6 rounded-2xl shadow-xl w-full max-w-md text-center">
          <h3 className="text-xl font-bold text-red-600 dark:text-red-300 mb-2">
            Authentication Failed
          </h3>
          <p className="text-red-500 dark:text-red-200 break-words text-sm">{errorMsg}</p>
          <p className="text-gray-500 dark:text-gray-400 mt-4 text-sm">
            Redirecting to login…
          </p>
        </div>
      </div>
    );
  }

  return <LoadingLines fullScreen />;
};

export default GoogleCallback;
